module.exports = __webpack_public_path__ + "img/6524.91cc676f.jpg";